import { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

export default function CreateUser() {
    const [inputs, setInputs] = useState({});
    const [message, setMessage] = useState("");


    const Navigate = useNavigate();
    const handleChange = (event) => {
        const name = event.target.name;
        const value = event.target.value;
        setInputs((values) => ({ ...values, [name]: value }));
    };

    const handleSubmit = (event) => {
        event.preventDefault();

        // Basic form validation
        if (!inputs.name || !inputs.email || !inputs.mobile) {
            setMessage("All fields are required.");
            return;
        }

        axios.post("https://api.interfacedataanddesignllp.com/user/save", inputs).then(function(response){
                console.log(response.data);
                Navigate('/');
            });
        }
    return (
        <div>
            <h1>Create Users</h1>
            <form onSubmit={handleSubmit}>
                <table cellSpacing={10}>
                    <tbody>
                        <tr>
                            <th>
                                <label>Name</label>
                            </th>
                            <td>
                                <input
                                    type="text"
                                    name="name"
                                    value={inputs.name || ""}
                                    onChange={handleChange}
                                />
                            </td>
                        </tr>
                        <tr>
                            <th>
                                <label>Email</label>
                            </th>
                            <td>
                                <input
                                    type="email"
                                    name="email"
                                    value={inputs.email || ""}
                                    onChange={handleChange}
                                />
                            </td>
                        </tr>
                        <tr>
                            <th>
                                <label>Mobile</label>
                            </th>
                            <td>
                                <input
                                    type="text"
                                    name="mobile"
                                    value={inputs.mobile || ""}
                                    onChange={handleChange}
                                />
                            </td>
                        </tr>
                        <tr>
                            <th></th>
                            <td>
                                <button type="submit">Submit</button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </form>

            {/* Display feedback message */}
            {message && <p>{message}</p>}
        </div>
    );
}
